import css from "./style.scss";
import cx from "classnames";
import { Text, MarkupText } from "preact-i18n";
import { svgIcons } from "../../helpers/svg-helpers";
import useInvoice from "../../hooks/useInvoice";

const DontClose = () => {
  const { invoice } = useInvoice();

  return (
    <div class={cx(css.wrapper)}>
      <div class={cx(css.icon)}>{svgIcons.info()}</div>
      <div class={cx(css.text)}>
        <MarkupText id="messages.do-not-close">
          Do not close this page. You will be redirecred to the next step as
          soon as your transaction is in mempool. Usually it takes a few
          minutes. If you paid, but you were not transferred to the next
          step,&nbsp;
          <a
            href={`mailto:Support@cryptoprocessing.io?subject=Help&body=Merchant:${invoice.store.store_name},  Order: ${invoice.store.id}, Date: `}
          >
            click here.
          </a>
        </MarkupText>
      </div>
    </div>
  );
};
export default DontClose;
